import { render, staticRenderFns } from "./OrderInfoFragment.vue?vue&type=template&id=2525ad6f"
import script from "./OrderInfoFragment.vue?vue&type=script&lang=js"
export * from "./OrderInfoFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports